import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useSelectableLegalEntityQuery } from "./useSelectableLegalEntityQuery";

export interface SelectableLegalEntityMultiSelectProps {
    selectedIds: Array<string>;
    onChange: (ids: Array<string>) => void;
    label: string;
    errorText?: string;
    disabled?: boolean;
    // A template preview renders the field without data, so it has nothing to fetch.
    disableQuery?: boolean;
}

function SelectableLegalEntityMultiSelect(props: SelectableLegalEntityMultiSelectProps) {
    const { translateString } = useTranslation();
    const { data, isLoading } = useSelectableLegalEntityQuery(!props.disableQuery);

    const options = data?.map((item) => ({ id: item.id, name: item.name }));

    return (
        <DotLegalMultiSelect
            isLoading={isLoading}
            options={options}
            chosenOptions={props.selectedIds}
            onChange={props.onChange}
            placeholder={props.label}
            label={props.label}
            noOptionsLabel={translateString("noOptions")}
            errorText={props.errorText}
            disabled={props.disabled}
        />
    );
}

export default SelectableLegalEntityMultiSelect;
